import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ScoreContainer(props) {
  const { resultObj, matchHasIrm } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  //const winner = resultObj?.wlt === 'W' && <div className='score-winner'><span className="mirsIconWinner" /></div>
  const result = resultObj?.result;
  const victoryByToss = resultObj?.wlt === 'V(T)' ? 'V(T) ' : ''
  return (
    <div className='score-result-container d-flex justify-content-end align-self-center'>
      <div className={`${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'} p-0 text-end `}>
        {resultObj?.hasIRM && <><SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true}/>&nbsp;</>}
        {victoryByToss}{result}
      </div>

      {matchHasIrm && !resultObj?.hasIRM && <div className="match-irm fw-bold"></div>}

    </div>
  )
}

export default ScoreContainer